export const getData = state => state.reportDriverHourlyOverview.getIn(['list', 'data'])
export const getFetching = state => state.reportDriverHourlyOverview.getIn(['list', 'fetching'])
export const getError = state => state.reportDriverHourlyOverview.getIn(['list', 'error'])

export const getDetailsData = state => state.reportDriverHourlyOverview.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportDriverHourlyOverview.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportDriverHourlyOverview.getIn(['details', 'error'])